import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Container } from 'reactstrap';
import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';
import '../../_Content/css/modal-termos-de-uso.css';

const idUsuario = localStorage.getItem('CodUsuario');
const administrador = localStorage.getItem('Administrador');

class TermosDeUso extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalFromFooter: this.props.abrirDoFooter,
		};
	}

	closeModal = () => {
		if (this.props.toggleModal) this.props.toggleModal();
	};

	aceitaTermos = () => {
		let data = new FormData();
		data.append('id', idUsuario);
		data.append('admin', administrador);

		return new Promise((resolve, reject) => {
			HttpUtil.eco_POST(
				`${Config.urls.API_URL_BASE}Acesso/AceitarTermos`,
				data,
				response => {
					resolve({ ok: response.data });
				},
				() => {
					console.log('erro');
				},
			);
		}).then(res => {
			if (res.ok) {
				localStorage.setItem('TermoUso', true);
				this.closeModal();
			}
		});
	};

	termosTxt = () => {
		return (
			<div className="termodeuso-txt-box">
				<h2>EcoAuditor</h2>
				<p>
					<span>
						<strong>Produto -&nbsp;</strong>O EcoAuditor é um produto disponibilizado pela Econet Editora,
						em que o cliente terá acesso à auditoria eletrônica dos arquivos EFD ICMS IPI, EFD CONTRIBUIÇÕES,
						ECF e ECD.
					</span>
				</p>
				<p>
					<span>
						O EcoAuditor possui como premissa simplificar a auditoria do arquivo SPED, apontando, na
						maioria dos casos, a solução para tais inconsistências, possibilitando que o erro ou o alerta
						sejam resolvidos de forma rápida e eficaz, além de contar com outras validações e cruzamentos
						não apontados pelos programas da RFB (Receita Federal do Brasil).
					</span>
				</p>
				<p>
					<span>
						<strong>Módulo EcoAuditor ECF -&nbsp;</strong>Efetua a auditoria eletrônica do arquivo do SPED ECF, no 
						formato "txt", através de comparativos das informações contidas no arquivo do cliente, com as regras 
						de negócios previstas no Guia Prático, sendo atualizadas constantemente de acordo com a legislação vigente, 
						e não contempla serviços de assessoria.
					</span>
				</p>
				<p>
					<span>
						<strong>Módulo EcoAuditor ECD -&nbsp;</strong>Efetua a auditoria eletrônica do arquivo do SPED ECD, no 
						formato "txt", através de comparativos das informações contidas no arquivo do cliente, com as regras 
						de negócios previstas no Guia Prático, sendo atualizadas constantemente de acordo com a legislação vigente, 
						e não contempla serviços de assessoria.
					</span>
				</p>
				<p>
					<span>
						<strong>Módulo EcoAuditor CONTRIBUIÇÕES -&nbsp;</strong>Efetua a auditoria eletrônica do arquivo do 
						SPED EFD CONTRIBUIÇÕES, no formato "txt", através de comparativos das informações contidas no arquivo do 
						cliente, com as regras de negócios previstas no Guia Prático, sendo atualizadas constantemente de acordo 
						com a legislação vigente, e não contempla serviços de assessoria.
					</span>
				</p>
				<p>
					<span>
						<strong>Módulo EFD ICMS IPI -&nbsp;</strong>Efetua a auditoria eletrônica do arquivo do SPED
						Fiscal (EFD ICMS IPI), no formato "txt", através de comparativos das informações contidas no
						arquivo do cliente, com as regras de negócios previstas no Guia Prático e Ato Cotepe ICMS
						09/2008, sendo atualizadas constantemente de acordo com a legislação vigente, e não contempla
						serviços de assessoria.
					</span>
				</p>
				<p>
					<span>
						A escrituração fiscal realizada na EFD ICMS IPI leva em consideração os documentos fiscais e
						demais documentos e informações sob o enfoque do declarante.
					</span>
				</p>
				<p>
					<span>
						<strong>Finalidade -&nbsp;</strong>Realizar a auditoria eletrônica das informações contidas no
						arquivo do cliente com as disposições previstas na legislação conforme Guia Prático e Ato Cotepe
						ICMS 09/2008, entre outras validações existentes.
					</span>
					<br />
				</p>
				<p>
					<span>
						Tem por objetivo informar aos clientes as inconformidades através de apontamentos na forma de
						"erros" ou "avisos", com as indicações dos registros e das linhas a serem analisadas e
						corrigidos (quando necessário).
					</span>
				</p>
				<p>
					<span>
						<strong>Obrigações do cliente -&nbsp;</strong>A análise das informações obtidas nos cruzamentos
						do arquivo será de inteira responsabilidade do usuário do sistema. Caberá ao cliente (usuário do
						sistema) observar a legislação específica para as escriturações fiscais realizadas e as
						particularidades previstas.
						<br />A data considerada para a escrituração é a partir de janeiro/2016. (Versão do layout do
						PVA 2.18)
					</span>
					<br />
				</p>
				<p>
					<span></span>
					<span>
						Caberá ao cliente realizar as correções/ ajustes (quando necessário) informadas pela ferramenta
						EcoAuditor antes do envio definitivo do arquivo ao fisco, através do PVA disponibilizado pela
						Receita Federal.
					</span>
				</p>
				<p>
					<span>
						<strong>Obrigações da Econet - </strong>O produto será disponibilizado na "área do Cliente" no
						site da Econet Editora, para acesso através da senha do cliente. A Econet prestará informações
						para a utilização do produto EcoAuditor sobre legislação pela consultoria e suporte técnico
						pela TI (por meio de atendimento telefônico), manual e demais conteúdos disponibilizados sobre o
						assunto. Para o primeiro acesso o cliente poderá realizar o contato para fins de auxílio
						juntamente ao Suporte Técnico, que realizará os esclarecimentos das dúvidas para a aplicação e
						utilização do produto.
					</span>
					<br />
				</p>
				<p>
					<span>
						Será disponibilizado o Manual de Apoio para a utilização do produto, que contemplará informações
						a respeito: da extração do arquivo, solução de erros e avisos alertados após a validação do
						arquivo, excel, lixeira, armazenamento das informações, atualizações e versões do produto.
						<br />
					</span>
				</p>
				<p>
					<span>
						Adequação de regras de negócios, considerando a necessidade da legislação vigente e sugestões
						encaminhadas pelos clientes quando possíveis de serem desenvolvidas.
						<br />
					</span>
				</p>
				<p>
					<span>As melhorias na ferramenta serão acompanhadas através das versões disponibilizadas.</span>
				</p>
				<p>
					<span>
						<strong>Garantia e responsabilidades -&nbsp;</strong>A interpretação da legislação e dos
						procedimentos fiscais descritos são de inteira responsabilidade do cliente (usuário do sistema).
					</span>
				</p>
				<p>
					<span>
						<strong>Termo de Confidencialidade -&nbsp;</strong>As informações contidas nos arquivos são
						mantidas em sigilo, exceto quando exigidas por força de lei ou requeridas para fins de processo
						judicial ou administrativo.
					</span>
				</p>
				<p>
					<span>
						<strong>Vantagens -&nbsp;</strong>É uma ferramenta que não necessita de instalação, é possível a
						identificação dos erros e avisos a serem sanados pelo cliente através de um relatório que
						possibilita a separação por registro.
					</span>
					<br />
				</p>
				<p>
					<span>
						Não há restrição na validação do arquivo, poderão ser realizadas várias vezes o upload do mesmo
						arquivo.
					</span>
				</p>
			</div>
		);
	};

	render() {
		return (
			<div>
				<Modal id="modal-termosDeUso" isOpen={this.props.modalOpen}>
					<ModalBody>
						<Container>
							<Row>
								<Col>
									<h1>Termos de Uso</h1>
								</Col>
								<Col>
									<img src="/img/assinatura-acesso-ilimitado.png" width="190" />
								</Col>
							</Row>
							<Row>
								<Col>{this.termosTxt()}</Col>
							</Row>
							<Row>
								<Col className="btnBox">
									<Button
										className="ecobtn fat baby-blue"
										outline
										color="primary"
										onClick={this.aceitaTermos}>
										Eu li e aceito os termos acima
									</Button>
								</Col>
							</Row>
						</Container>
					</ModalBody>
				</Modal>

				<Modal id="modal-termosDeUso" isOpen={this.props.abrirDoFooter} toggle={this.props.action}>
					<ModalHeader toggle={this.props.action} onClick={this.props.action}>
						<i className="fas fa-times"></i>
					</ModalHeader>
					<ModalBody className="modalFooter">
						<Container>
							<Row>
								<Col>
									<h1>Termos de Uso</h1>
								</Col>
							</Row>
							<Row>
								<Col>
									<h1>
										<img src="/img/assinatura-acesso-ilimitado.png" width="370" />
									</h1>
								</Col>
							</Row>
							<Row>
								<Col>{this.termosTxt()}</Col>
							</Row>
							<Row>
								<Col className="btnBox">
									<Button className="ecobtn fat vazado vermelho fechar" onClick={this.props.action}>
										Fechar
									</Button>
								</Col>
							</Row>
						</Container>
					</ModalBody>
				</Modal>
			</div>
		);
	}
}

export default TermosDeUso;



// WEBPACK FOOTER //
// ./src/Componente/TermosDeUso/TermosDeUso.jsx